export default __webpack_public_path__ + "static/media/ESheader.e1166c83.png";